//exporting as individual constants to enable higher compatibility with Compiled.css

export const WCL_GRID_PADDING_SM = 32;
export const WCL_GRID_PADDING_LG = 60;
export const WCL_GRID_PADDING_XL = 136;
export const WCL_GRID_MAX_WIDTH = 1152;
export const WCL_GRID_MAX_WIDTH_XL = 1648;

export const WCL_EXTENDED_BACKGROUND_EXTRA_WIDTH = 80;
